module.exports = __webpack_public_path__ + "static/media/station.b15481f6.png";